import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Paper } from '@mui/material';
import Grid from 'material/components/Grid';

import { fetchTextBroadcast, fetchTextBroadcastRecipients } from 'store/actions/broadcasts';
import { broadcastsSelectors } from 'store/selectors/broadcasts';

import {
  Backdrop,
  BreadcrumbsNavigation,
  Container,
  RecipientsTable,
  TabPanel,
  Tabs,
} from 'common/components';

import TextBroadcastTopCard from '../components/TextBroadcastTopCard';
import TextBroadcastOverview from '../components/TextBroadcastOverview';

const StyledPaper = styled(Paper)`
  border-bottom: 0;
`;

const BroadcastTablesWrapper = styled.div`
  margin: 0 0 82px;
`;

const TextBroadcastDetails = () => {
  const dispatch = useDispatch();
  const { broadcastUuid, organizationUuid } = useParams();

  const {
    broadcastRecipients,
    isBroadcastFetching,
    isBroadcastRecipientsFetching,
    textBroadcastDetails,
  } = useSelector(state => ({
    broadcastRecipients: broadcastsSelectors.getBroadcastRecipients(state),
    isBroadcastFetching: broadcastsSelectors.isBroadcastFetching(state),
    isBroadcastRecipientsFetching: broadcastsSelectors.isBroadcastRecipientsFetching(state),
    textBroadcastDetails: broadcastsSelectors.getTextBroadcastDetails(state),
  }));

  useEffect(() => {
    dispatch(fetchTextBroadcast(broadcastUuid));
    dispatch(fetchTextBroadcastRecipients(broadcastUuid));
  }, []);

  const [tabIndex, setTabIndex] = useState('recipients');

  const { name } = textBroadcastDetails;

  const breadcrumbs = [
    {
      link: `/${organizationUuid}/broadcasts`,
      name: 'Broadcasts',
    },
    {
      link: '',
      name,
    },
  ];

  const handleChangeTablesTab = newValue => {
    setTabIndex(newValue);
  };

  const textBroadcastTabs = [
    {
      label: 'Recipients',
      value: 'recipients',
    },
  ];

  return (
    <>
      <BreadcrumbsNavigation links={breadcrumbs} />
      <Container>
        <Grid container>
          <TextBroadcastTopCard />
        </Grid>
        <Grid container>
          <TextBroadcastOverview />
        </Grid>
        <BroadcastTablesWrapper>
          <StyledPaper square variant="outlined">
            <Tabs
              handleSetTab={handleChangeTablesTab}
              tabs={textBroadcastTabs}
              tabIndex={tabIndex}
            />
          </StyledPaper>
          <TabPanel index={textBroadcastTabs[0].value} value={tabIndex}>
            <RecipientsTable
              isDataFetching={isBroadcastRecipientsFetching}
              isTextRecipients
              recipients={broadcastRecipients}
            />
          </TabPanel>
        </BroadcastTablesWrapper>
        <Backdrop isOpen={isBroadcastFetching} />
      </Container>
    </>
  );
};

export default TextBroadcastDetails;
